import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import CapitalLedgerFilter from "./components/CapitalLedgerFilter";
import CapitalLedgerTable from "./components/CapitalLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const CapitalLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const { filters } = useSelector((state) => state.capitalLedger);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Capital Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }}>
              Capital Ledger
            </Title>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <CapitalLedgerFilter messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <CapitalLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Capital Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <CapitalLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default CapitalLedger;
